import React from "react"
import {connect} from "react-redux";
import {replace} from "react-router-redux";
import {Tabs, Tab} from 'react-bootstrap';
import {getUrlParams, getPageContext, removePath} from "../../common/utils";
import LogInScreen from "../login/LogInScreen";
import {initServerStaticData} from "../../actions/common/staticDataActions";
import {initMemberData, setMemberKey} from "../../actions/login/memberDetailsActions";
import {getSubscriptionSummary} from "../../actions/account/accountActions";
import {checkIsDirty, setAndRemoveUrlParams, setDirty} from '../../actions/common/commonActions';
import UserMenu from "../../containers/common/UserMenu";
import ModalPopup from "../../components/common/ModalPopup";
import SelectionTabs from "../../components/common/SelectionTabs";
import SelectionPane from "../../components/common/SelectionPane";
import AccountNavigationHeader from "../../components/account/AccountNavigationHeader";
import PaymentPane from "../../components/pay/PaymentPane";
import {makeExtraPayment, redirectToPaymentDetails, updatePaymentPlan, adminChargeWithToken, adminChargeWithoutToken, removeAutomaticPayment} from "../../actions/pay/paymentActions";
import {PaymentMethod, PaymentPlans, URLs, PaymentTypes, FetchingTypes} from "../../common/constants";
import ThankYouPage from "../../components/common/ThankYouPage";
import PaymentsHost from "./PaymentsHost";
import EcheckForm from "./EcheckForm";
import EBTForm from "./EBTForm";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {setPaymentType, setAllowContinuePayment} from "../../actions/common/subscriptionSummaryActions";
import {isFetching} from "../../actions/common/fetchingActions";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/payment/payHomeScreen.less";

class PayHomeScreen extends React.Component {
    constructor(props) {
        super(props);
        const page = props.staticData.farmKey ?
            props.location.pathname.includes('/ebt') && props.allowContinue ? "EBTForm" :
            (props.location.pathname.includes('/thankyou') ? "ThankYouPage" : "Tabs") :
                "LoadingAnimation";

        this.state = {
          page
      };
    }

    componentWillMount() {
        if (this.props.staticData.farmKey) {
            this.props.setAndRemoveUrlParams(true);
            return;
        }
        this.props.initServerStaticData();
        if (getPageContext() === URLs.CHARGE)
            this.props.setMemberKey(getUrlParams().memberKey);
        else if (getUrlParams().mode === 'preview')
            this.props.setMemberKey(getUrlParams().m);
        else
            this.props.initMemberData();
        if (getUrlParams().type === 'single') {
            this.props.setPaymentType(PaymentTypes.SINGLE_PAYMENT.type);
        }
        this.props.setAndRemoveUrlParams(true);
    }

    getPath = () => {
        this.props.getPath("/" + URLs.PAY + "/" + this.props.params.splat.split("/")[1] + "?source=account");
    };

    getPage = (props) => {
        const path = props.location.pathname.split(";")[0];
        if(path.endsWith('/thankyou')) {
            this.setState({page: "ThankYouPage"});
        } else if (!props.memberDetails.key) {
            this.setState({page: "LogInScreen"});
        }else if (path.endsWith('/echeck')){
            if(this.props.allowContinue) {
                this.setState({page: "EcheckForm"});
            } else {
                this.props.getPath(removePath('/echeck'));
            }
        }else if (path.endsWith('/ebt')){
            if(this.props.allowContinue) {
                this.setState({page: "EBTForm"});
            } else {
                this.props.getPath(removePath('/ebt'));
            }
        }else if (path.endsWith('/payments')) {
            if(this.props.allowContinue) {
                this.setState({page: "PaymentsHost"});
            } else {
                this.props.getPath(removePath('/payments'));
            }
        } else if(props.paymentMethods && props.paymentPlans) {
            this.setState({page: "Tabs"});
        } else {
            this.setState({page: "LoadingAnimation"});
        }
    };

    componentWillReceiveProps(nextProps) {
        this.getPage(nextProps);
        if(nextProps.memberDetails.key && !this.props.memberDetails.key) {
            this.props.getSubscriptionSummary(this.props.isAdminPayments, true);
        }
        if((nextProps.paymentType === PaymentTypes.SINGLE_PAYMENT.type && nextProps.singlePaymentPlan && nextProps.singlePaymentMethod) ||
            (nextProps.paymentType === PaymentTypes.AUTO_PAYMENT.type && nextProps.autoPaymentPlan) ||
            (nextProps.paymentType === PaymentTypes.UPDATE_PAYMENT.type && nextProps.updatePaymentMethod)) {
            if(nextProps.paymentType === PaymentTypes.SINGLE_PAYMENT.type &&
                nextProps.singlePaymentPlan.type === PaymentPlans.CustomPrePayment && nextProps.paymentPlanAmount === 0) {
                this.props.setAllowContinuePayment(false);
            } else if(nextProps.paymentType === PaymentTypes.AUTO_PAYMENT.type && (!nextProps.autoPaymentMethod && !nextProps.hasToken)) {
                this.props.setAllowContinuePayment(false);
            } else {
                this.props.setAllowContinuePayment(!this.props.isPreview);
            }
        } else if (nextProps.paymentType === PaymentTypes.CHARGE.type && nextProps.chargePaymentPlan && nextProps.chargePaymentMethod) {
            this.props.setAllowContinuePayment(nextProps.paymentPlanAmount > 0);
        } else if (nextProps.paymentType === PaymentTypes.PAYMENT_PLAN.type && nextProps.planPaymentPlan) {
            this.props.setAllowContinuePayment(true);
        } else if (nextProps.paymentType === PaymentTypes.PAYMENT_TOKEN.type) {
            this.props.setAllowContinuePayment(nextProps.tokenPaymentMethod);
        } else if(nextProps.allowContinue){
            this.props.setAllowContinuePayment(false);
        }
        if(nextProps.paymentPlans && !this.props.paymentPlans && !nextProps.paymentType) {
            const tabs = this.props.isAdminPayments ? this.getAdminTabsData(nextProps) : this.getTabsData(nextProps);
            if(tabs.length > 0) {
                this.props.setPaymentType(tabs[0].key);
            }
        }
    }

    getButtons = () => {
        const submitLoadingClass = this.props.showLoading? " loading" : "";
        const submitClasses = "submit-order button" +  submitLoadingClass;
        return(
        {
            left: {
                label: translate("BACK"),
                onClick: this.onBack,
                invisible: !this.props.showBack,
                className: "back button"
            },
            right: {
                label: translate("CONTINUE"),
                onClick: this.onContinue,
                disabled: !this.props.allowContinue,
                className: submitClasses
            }
        });
    };

    onBack = () => {
        this.props.checkIsDirty(!this.props.isPreview, function() {
            this.props.goBack();
        }.bind(this));
    };

    onContinue = () => {
        this.props.setAllowContinuePayment(this.props.paymentType === PaymentTypes.CHARGE.type);
        if(this.props.paymentType === PaymentTypes.SINGLE_PAYMENT.type) {
            //Positive amount should be sent only for custom payment
            const amount = this.isCustomPayment(this.props.singlePaymentPlan.key) ? this.props.singlePaymentPlan.amount : 0;
            this.props.makeExtraPayment("ACCOUNT", amount, this.props.singlePaymentMethod, this.props.singlePaymentPlan);
        } else if(this.props.hasToken && this.props.paymentType === PaymentTypes.AUTO_PAYMENT.type) {
            this.props.updatePaymentPlan(this.props.autoPaymentPlan);
        } else if (this.props.paymentType === PaymentTypes.CHARGE.type) {
            if (this.hasTokenForAdminCharge())
                this.props.adminChargeWithToken();
            else
                this.props.adminChargeWithoutToken();
        } else if (this.props.paymentType === PaymentTypes.PAYMENT_PLAN.type) {
            this.props.updatePaymentPlan(this.props.planPaymentPlan);
        } else if ((this.props.paymentType === PaymentTypes.PAYMENT_TOKEN.type && (this.props.tokenPaymentMethod === PaymentMethod.NONE.key)) ||
            (this.props.paymentType === PaymentTypes.UPDATE_PAYMENT.type && (this.props.updatePaymentMethod === PaymentMethod.NONE.key) && this.props.staticData.allowMemberToRemoveToken)) {
            this.openRemoveTokenPopup();
        } else {
            const paymentPlan = !this.props.hasToken?this.props.autoPaymentPlan:undefined;
            this.props.redirectToPaymentDetails("UPDATE_PAYMENT_DETAILS", this.props[this.props.paymentType+"PaymentMethod"], paymentPlan);
        }
    };

    isCustomPayment = (paymentPlanKey) => {
        return this.props.paymentPlans.some(plan => {
           return (plan.key === paymentPlanKey && plan.type === PaymentPlans.CustomPrePayment)
        });
    };

    getPreApprovalText = () => {
        const preApprovalText = (this.props.isAdminPayments ? translate("Member is") : translate("You are")) + " " + translate("_assignedAutomaticPayment");
        switch (this.props.paymentMethodToken){
            case (PaymentMethod.PAYPAL_PREAPPROVE.key) :
                return preApprovalText + "PayPal";
            case (PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key) :
                return preApprovalText + translate("AUTHORIZE_DOT_NET");
            case (PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key) :
                return preApprovalText + translate("ELECTRONIC_CHECK");
            default:
                return "";
        }
    };

    getPaymentPlanText = () => {
        if (!this.props.subscriptionPaymentPlan || [PaymentPlans.F, PaymentPlans.AutoRecurring, PaymentPlans.PresetRecurring].includes(this.props.subscriptionPaymentPlan.type)) {
            return '';
        }
        return translate("Your current payment plan") + " : " + this.props.subscriptionPaymentPlan.title;
    };

    setSelectedTab = (tabLabel) => {
        for (const payment in PaymentTypes) {
            if (PaymentTypes.hasOwnProperty(payment) && PaymentTypes[payment].label === tabLabel) {
                this.props.setPaymentType(PaymentTypes[payment].type);
                return;
            }
        }
    };

    openRemoveTokenPopup = () => {
        this.setState({showRemoveTokenPopup: true});
    };

    closeRemoveTokenPopup = () => {
        this.setState({showRemoveTokenPopup: false});
    };

    getRemoveTokenPopup = () => {
        if(this.state.showRemoveTokenPopup) {
            return (
                <ModalPopup
                    onClose={this.closeRemoveTokenPopup}
                    message="removeAutomaticPaymentConfirmation"
                    right={{text:'Remove', callback:this.props.removeAutomaticPayment}}
                    left={{text:'Cancel', callback:this.closeRemoveTokenPopup}}/>
            );
        }
    };

    hasTokenForAdminCharge = () => {
        return (this.props.hasToken && (this.props.paymentMethodToken === PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key || this.props.paymentMethodToken === PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key))
    };

    getAdminChargePaymentMethods = (nextProps) => {
        const props = nextProps?nextProps:this.props;
        if (this.hasTokenForAdminCharge())
            return [props.paymentMethodToken];

        let paymentMethods = [];
        let allPaymentMethods = props.staticData.signupPaymentMethods.concat(props.staticData.makePaymentPaymentMethods);
        if (allPaymentMethods.includes(PaymentMethod.AUTHORIZE_DOT_NET.key) || allPaymentMethods.includes(PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key))
            paymentMethods.push(PaymentMethod.AUTHORIZE_DOT_NET.key);
        if (allPaymentMethods.includes(PaymentMethod.ELECTRONIC_CHECK.key) || allPaymentMethods.includes(PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key))
            paymentMethods.push(PaymentMethod.ELECTRONIC_CHECK.key);
        if (allPaymentMethods.includes(PaymentMethod.EBT_ONLINE.key))
            paymentMethods.push(PaymentMethod.EBT_ONLINE.key);

        return paymentMethods;
    };

    getAdminAutoPaymentMethods = (nextProps) => {
        const props = nextProps?nextProps:this.props;
        let paymentMethods = [];
        let allPaymentMethods = props.staticData.signupPaymentMethods.concat(props.staticData.makePaymentPaymentMethods);
        if (allPaymentMethods.includes(PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key))
            paymentMethods.push(PaymentMethod.AUTHORIZE_DOT_NET_PREAPPROVE.key);
        if (allPaymentMethods.includes(PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key))
            paymentMethods.push(PaymentMethod.ELECTRONIC_CHECK_PREAPPROVE.key);

        return paymentMethods;
    };

    getAdminPaymentPlans = (nextProps) => {
        return nextProps?nextProps.paymentPlans:this.props.paymentPlans;
    };

    getAdminMemberName = () => {
        const params = getUrlParams();
        if (params)
            return params.firstName + " " + params.lastName;
        return "";
    };

    getPaymentPane = (paymentType) => {
        const paymentMethods = paymentType === PaymentTypes.PAYMENT_PLAN.type ? [] :
            paymentType === PaymentTypes.CHARGE.type ? this.getAdminChargePaymentMethods() :
                paymentType === PaymentTypes.PAYMENT_TOKEN.type ? this.getAdminAutoPaymentMethods() :
                    paymentType === PaymentTypes.UPDATE_PAYMENT.type ? this.props.autoPaymentMethods :
                        this.props[paymentType + "PaymentMethods"];
        const paymentPlans = paymentType === PaymentTypes.PAYMENT_TOKEN.type ? [] :
            paymentType === PaymentTypes.PAYMENT_PLAN.type ? this.getAdminPaymentPlans() :
                paymentType === PaymentTypes.CHARGE.type ? [{type:PaymentPlans.CustomPrePayment, key:"_custom_prepayment"}] :
                    this.props[paymentType + "PaymentPlans"];

        return (<PaymentPane paymentMethods={paymentMethods}
                             staticData={this.props.staticData}
                             paymentPlans={paymentPlans}
                             paymentType={paymentType}
                             allowNone={this.props.isAdminPayments || (this.props.staticData.allowMemberToRemovePaymentPlan && this.props.hasToken && this.props.subscriptionPaymentPlan && paymentType === PaymentTypes.AUTO_PAYMENT.type)}
                             hasToken={this.props.hasToken}/>);
    };

    getPaymentTitle = () => {
        if(!this.props.paymentType) {
            return undefined;
        }
        switch(this.props.paymentType) {
            case PaymentTypes.SINGLE_PAYMENT.type:
                return PaymentTypes.SINGLE_PAYMENT.label;
            case PaymentTypes.AUTO_PAYMENT.type:
                return PaymentTypes.AUTO_PAYMENT.label;
            case PaymentTypes.UPDATE_PAYMENT.type:
                return PaymentTypes.UPDATE_PAYMENT.label;
        }
    };

    getUserMenu = () => {
        if (!this.props.clientViewPort.isXs && !this.props.isAdminPayments && !this.props.isPreview)
            return (<UserMenu/>);
        if (!this.props.clientViewPort.isXs && this.props.isPreview)
            return (<div className="preview-label">{translate("Preview")}</div>);
    };

    getTabsData = (nextprops) => {
        const props = nextprops?nextprops:this.props;
        let tabs = [];
        if (props.autoPaymentMethods.length > 0 && (props.autoPaymentPlans||{}).length > 0) {
            tabs.push({
                title: PaymentTypes.AUTO_PAYMENT.label,
                shortTitle: PaymentTypes.AUTO_PAYMENT.shortLabel,
                key: PaymentTypes.AUTO_PAYMENT.type,
                content: this.getPaymentPane(PaymentTypes.AUTO_PAYMENT.type)
            });
        }
        if (props.singlePaymentMethods.length > 0 && (props.singlePaymentPlans||{}).length > 0) {
            const singlePaymentTab = {
                title: PaymentTypes.SINGLE_PAYMENT.label,
                shortTitle: PaymentTypes.SINGLE_PAYMENT.shortLabel,
                key: PaymentTypes.SINGLE_PAYMENT.type,
                content: this.getPaymentPane(PaymentTypes.SINGLE_PAYMENT.type)
            }
            if (this.props.staticData.makePaymentSinglePaymentFirst) {
                tabs.unshift(singlePaymentTab);
            } else {
                tabs.push(singlePaymentTab);
            }
        }
        if (props.hasToken && props.autoPaymentMethods.length > 0) {
            tabs.push({
                title: PaymentTypes.UPDATE_PAYMENT.label,
                shortTitle: PaymentTypes.UPDATE_PAYMENT.shortLabel,
                key: PaymentTypes.UPDATE_PAYMENT.type,
                content: this.getPaymentPane(PaymentTypes.UPDATE_PAYMENT.type)
            });
        }
        return tabs;
    };

    getAdminTabsData = (nextProps) => {
        const props = nextProps?nextProps:this.props;
        let tabs = [];
        if (this.getAdminChargePaymentMethods(props).length > 0)
            tabs.push({
                title:PaymentTypes.CHARGE.label,
                shortTitle:PaymentTypes.CHARGE.shortLabel,
                key:PaymentTypes.CHARGE.type,
                content:this.getPaymentPane(PaymentTypes.CHARGE.type)});
        if (this.getAdminPaymentPlans(props).length > 0)
            tabs.push({
                title:PaymentTypes.PAYMENT_PLAN.label,
                shortTitle:PaymentTypes.PAYMENT_PLAN.shortLabel,
                key:PaymentTypes.PAYMENT_PLAN.type,
                content:this.getPaymentPane(PaymentTypes.PAYMENT_PLAN.type)});
        if (this.getAdminAutoPaymentMethods(props).length > 0 || props.hasToken)
            tabs.push({title:PaymentTypes.PAYMENT_TOKEN.label,
                shortTitle:PaymentTypes.PAYMENT_TOKEN.shortLabel,
                key:PaymentTypes.PAYMENT_TOKEN.type,
                content:this.getPaymentPane(PaymentTypes.PAYMENT_TOKEN.type)});
        return tabs;
    };

    getTabsMobile = (hasToken) => {
        const tabs = this.props.isAdminPayments ? this.getAdminTabsData() : this.getTabsData();
        if (tabs.length === 0)
            return null;
        return (
            <Tabs id="payments-tab"
                  defaultActiveKey={tabs[0].title} className={hasToken ? "has-token" : ""}
                  onSelect={this.setSelectedTab}>
                {tabs.map(tab => {
                    return <Tab title={tab.shortTitle} unmountOnExit={true} eventKey={tab.title}
                                key={tab.title} tabClassName={"_" + tabs.length}>{tab.content}</Tab>
                })}
            </Tabs>
        )
    };

    getTabs = () => {
        const tabs = this.props.isAdminPayments ? this.getAdminTabsData() : this.getTabsData();
        if (tabs.length === 0)
            return null;
        return (
            <SelectionTabs update={this.setSelectedTab} selectedTabTitle={this.getPaymentTitle()}>
                {tabs.map(tab => {
                    return <SelectionPane label={tab.title} key={tab.key}>{tab.content}</SelectionPane>
                })}
            </SelectionTabs>
        )
    };

    renderPage = () => {
        switch (this.state.page) {
            case "ThankYouPage":
                return (<ThankYouPage pageContext={getPageContext()} seasonUrl={this.props.staticData.seasonUrl}
                                      memberKey={this.props.memberDetails.key}
                                      mode={this.props.paymentType}
                                      extraMessage={(this.props.staticData.params || {}).message}
                                      farmUrl={this.props.staticData.farmUrl}/>);
            case "LogInScreen":
                return (<LogInScreen/>);
            case "EcheckForm":
                const totalToPay = this.props.paymentType !== PaymentTypes.PAYMENT_TOKEN.type ? this.props[this.props.paymentType + "PaymentPlan"].totalToPay : undefined;
                return (
                    <EcheckForm pageContext={URLs.PAY} amount={this.props.paymentPlanAmount} totalToPay={totalToPay}/>);
            case "EBTForm":
                const totalToCharge = this.props.paymentType !== PaymentTypes.PAYMENT_TOKEN.type ? this.props[this.props.paymentType + "PaymentPlan"].totalToPay : undefined;
                return (
                    <EBTForm pageContext={URLs.PAY} amount={this.props.paymentPlanAmount} totalToPay={totalToCharge}/>);
            case "PaymentsHost":
                return (<PaymentsHost pageContext={this.props.isAdminPayments ? URLs.CHARGE : URLs.PAY}/>);
            case "LoadingAnimation":
                return (<LoadingAnimation/>);
            case "Tabs":
                const title = !this.props.isAdminPayments ? translate("Manage Payments") :
                    ((!this.props.clientViewPort.isXs ? "Manage Payments | " : "") + this.getAdminMemberName());
                const showPreApprovalHeader = this.props.hasPreapproval && this.props.subscriptionPaymentPlan;
                return (<div className={"manage-payment-screen" + (this.props.clientViewPort.isXs ? "-mobile" : "")}>
                    <fieldset disabled={this.props.showLoading}>
                        <AccountNavigationHeader buttons={this.getButtons()} title={title}
                                                 fullWidth={this.props.isAdminPayments}/>
                        {this.getUserMenu()}
                        {this.props.hasPreapproval || this.props.subscriptionPaymentPlan ?
                            <div className="preapproval-text">
                                {showPreApprovalHeader && this.getPreApprovalText()}
                                {!showPreApprovalHeader ? undefined : this.props.clientViewPort.isXs ? '; ' : <br/>}
                                {this.props.subscriptionPaymentPlan && this.getPaymentPlanText()}
                                </div>
                            : undefined
                        }
                        {this.props.clientViewPort.isXs ?
                            this.getTabsMobile(this.props.hasPreapproval || this.props.subscriptionPaymentPlan)
                            :
                            this.getTabs()
                        }
                    </fieldset>
                    {this.getRemoveTokenPopup()}
                </div>);
        }
    };

    render() {
        return(
            this.renderPage()
        )
    }
}

const mapStateToProps = (state) => {
    const summary = state.summary;
    const isAdminPayments = getPageContext() === URLs.CHARGE;
    return {
        clientViewPort: (state.clientViewPort || {}),
        staticData: state.staticData,
        isAdminPayments: isAdminPayments,
        isPreview: (state.staticData || {}).isPreview,
        memberDetails: state.memberDetails || {},
        hasPreapproval: summary.hasPreapproval,
        singlePaymentPlan: summary.singlePaymentPlan,
        singlePaymentMethod: summary.singlePaymentMethod,
        autoPaymentPlan: summary.autoPaymentPlan,
        autoPaymentMethod: summary.autoPaymentMethod,
        updatePaymentMethod: summary.updatePaymentMethod,
        chargePaymentPlan: summary.chargePaymentPlan,
        chargePaymentMethod: summary.chargePaymentMethod,
        planPaymentPlan: summary.planPaymentPlan,
        tokenPaymentMethod: summary.tokenPaymentMethod,
        paymentMethodToken: summary.paymentMethodToken,
        paymentPlans: summary.makePaymentPaymentPlans,
        paymentMethods: summary.makePaymentPaymentMethods,
        singlePaymentMethods: summary.singlePaymentMethods || {},
        autoPaymentMethods: summary.autoPaymentMethods || {},
        singlePaymentPlans: summary.singlePaymentPlans,
        autoPaymentPlans: summary.autoPaymentPlans,
        subscriptionPaymentPlan: summary.paymentPlan,
        paymentPlanAmount: isAdminPayments ? (summary.chargePaymentPlan || {}).amount : (summary.singlePaymentPlan || {}).amount,
        showBack: getUrlParams().source === 'account',
        paymentType: summary.paymentType,
        hasToken: summary.hasToken,
        allowContinue: summary.allowContinuePayment,
        showLoading: isFetching(state, FetchingTypes.SUBMIT)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        initServerStaticData: () => {
          dispatch(initServerStaticData());
        },
        initMemberData: () => {
            dispatch(initMemberData());
        },
        setAndRemoveUrlParams: (onlyHidden) => {
            dispatch(setAndRemoveUrlParams(onlyHidden));
        },
        setMemberKey: (memberKey) => {
            dispatch(setMemberKey(memberKey));
        },
        getSubscriptionSummary: (asAdmin, withBalance) => {
            dispatch(getSubscriptionSummary(asAdmin, withBalance));
        },
        checkIsDirty: (check, onLeaveCallBack) => {
            if (check)
                dispatch(checkIsDirty(onLeaveCallBack));
            else
                onLeaveCallBack();
        },
        goBack: () => {
            dispatch(setDirty(false));
            window.history.back();
        },
        makeExtraPayment: (clientMode, amount, paymentMethod, paymentPlan) => {
          dispatch(makeExtraPayment(clientMode, amount, paymentMethod, paymentPlan));
        },
        redirectToPaymentDetails: (clientMode, paymentMethod, paymentPlan) => {
            dispatch(redirectToPaymentDetails(clientMode, paymentMethod, paymentPlan));
        },
        updatePaymentPlan: (paymentPlan) => {
            dispatch(updatePaymentPlan(paymentPlan.key !== 'none' ? paymentPlan : undefined));
        },
        getPath: (path) => {
            dispatch(replace(path));
        },
        setPaymentType: (paymentType) => {
            dispatch(setPaymentType(paymentType));
        },
        setAllowContinuePayment: (allowContinuePayment) => {
            dispatch(setAllowContinuePayment(allowContinuePayment));
        },
        adminChargeWithToken: () => {
            dispatch(adminChargeWithToken());
        },
        removeAutomaticPayment: () => {
            dispatch(removeAutomaticPayment());
        },
        adminChargeWithoutToken: () => {
            dispatch(adminChargeWithoutToken());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (PayHomeScreen);


// WEBPACK FOOTER //
// ./src/containers/pay/PayHomeScreen.js